import { IconTextButtonBlock } from 'components/minute/view/IconTextButtonBlock';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { EColors, EFonts, EShadows } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MobileModal = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    return (
        <S_MobileModal className={props.className}>
            <S_IconTextButtonBlock
                iconName="laptop-mobile"
                title={Localization.USE_COMPUTER}
                subtitle={Localization.USE_COMPUTER_DESC}
            />
            <S_WebButton
                shadow={EShadows.LIGHT}
                type={'primary'}
                text={Localization.CONTINUE_ANYWAY}
                onClick={() => {
                    ctxModal.setModal(null);
                }}
            />
            <S_Link href="https://mapheim.com" target="_blank">
                {Localization.GO_TO_HOMEPAGE}
            </S_Link>
        </S_MobileModal>
    );
};

const S_MobileModal = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #f8f8f8;
    box-shadow: ${EShadows.STRONG};
    border-radius: 7px;
    height: 100%;
    align-items: center;
`;

const S_IconTextButtonBlock = styled(IconTextButtonBlock)`
    padding: 0 20px;
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 15px 0 20px 0;
    background: linear-gradient(270deg, #ff5a5a 0%, #ff9999 100%);
    color: white;
`;

const S_Link = styled.a`
    font-size: 15px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Medium};
    line-height: 25px;
    text-decoration: underline;
`;
